const getInitialState = () => ({});
export default getInitialState();
